/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon/Icon';
import accessTokenService from 'services/accessTokenService';
import { sourceFromFeed } from 'Actions/ResearchActions';
import { withTranslate } from 'react-redux-multilingual';

const PdfLink = props => {
	const { format } = window;
	const {
		researchId,
		documentId,
		headline,
		docDate,
		feedId,
		fileSize,
		className,
		inlineFileSize,
		translate,
		sourceOnSecondLine,
		hideFileSize,
		anchorClassName,
		wcUSsuage
	} = props;

	const { MD } = window;
	const { markitDigitalUrl } = MD || {};

	const inlineFileSizeCopy = !hideFileSize ? (
		<>
			{' ('}
			{format.fileSize(fileSize)}
			{')'}
		</>
	) : null;

	const fileSizeCopy = !hideFileSize ? (
		<>
			{` - ${sourceFromFeed(feedId)} - (`}
			{format.fileSize(fileSize)}
			{')'}
		</>
	) : (
		<>
			{` - ${sourceFromFeed(feedId)} `}
		</>
	);

	const handleLinkClickEvent = () => {
		const { clickCallback } = props;
		if (clickCallback) {
			clickCallback();
		}
	};


	return (
		<>
			<p className={`font-weight-bold ${className}`}>
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={`${wcUSsuage ? markitDigitalUrl : ''}/getpdf/${researchId}/${documentId}?token=${accessTokenService.retrieve()}`}
					onClick={handleLinkClickEvent}
					className={`${anchorClassName}`}>
					<span aria-hidden>{format.string(headline)}</span>
					<span className="sr-only">{translate('openPdfInANewWindow', { title: format.string(headline) })}</span>
				</a>
				{
					inlineFileSize
						? (
							<span className="file-size">
								{inlineFileSizeCopy}
								<Icon iconName="document" className="pdf-icon" style={{ width: '16px', height: '16px' }} />
							</span>
						) : null
				}
			</p>
			{
				!inlineFileSize && sourceOnSecondLine
					? (
						<p className="research-metadata">
							{format.monthDayLongYear(docDate)}
							{fileSizeCopy}
							<Icon iconName="document" className="pdf-icon" style={{ width: '16px', height: '16px' }} />
						</p>
					) : null
			}

		</>
	);
};

PdfLink.propTypes = {
	className: PropTypes.string,
	researchId: PropTypes.number.isRequired,
	documentId: PropTypes.string.isRequired,
	headline: PropTypes.string,
	docDate: PropTypes.string,
	feedId: PropTypes.number,
	fileSize: PropTypes.number,
	inlineFileSize: PropTypes.bool,
	hideFileSize: PropTypes.bool,
	translate: PropTypes.func,
	sourceOnSecondLine: PropTypes.bool,
	anchorClassName: PropTypes.string,
	wcUSsuage: PropTypes.bool
};

PdfLink.defaultProps = {
	className: '',
	headline: null,
	docDate: null,
	feedId: null,
	fileSize: null,
	inlineFileSize: false,
	hideFileSize: false,
	translate: () => {},
	sourceOnSecondLine: true,
	anchorClassName: '',
	wcUSsuage: false
};

export default withTranslate(PdfLink);
